import { RouteObject } from 'react-router-dom'
import SignInPage from './pages/SignInPage'

const authRoutes: RouteObject = {
	path: '/login',
	element: <SignInPage />,
	children: [],
}

export default authRoutes
